import { useApi } from '@omnipresentgroup/api';
import type {
  FileFormat,
  InvoiceReportNetSuiteType,
} from '@omnipresentgroup/types';

import { API_BASE, INVOICE_REPORT_DOWNLOAD_API_PATH } from '../constants';

export const useInvoiceReportDownload = () => {
  const { GET } = useApi();

  const downloadInvoiceReport = (
    companyId: string,
    invoiceId: string,
    format: FileFormat,
    type: InvoiceReportNetSuiteType,
  ) =>
    GET(
      `${API_BASE}/${INVOICE_REPORT_DOWNLOAD_API_PATH(companyId, invoiceId)}`,
      {},
      {
        format,
        type,
      },
    );
  return downloadInvoiceReport;
};
